export default __webpack_public_path__ + "static/media/button_img.524c722b.jpg";